import { EstateType } from '/@/modules/estate/enums/EstateType';
import { user, echo } from '@/modules/auth/store/auth.state';
import { AuthUser } from '@/modules/auth/models/AuthUser';
import { CurrentEstate } from '/@/modules/estate/models/CurrentEstate';
import Echo from 'laravel-echo';
import { Estate } from '@/modules/estate/models/Estate';
import { AuthUserPermission } from '@/modules/auth/models/AuthUserPermission';

export function getUser(): AuthUser | null {
  return user.value;
}

export function getCurrentEstate(): CurrentEstate | null | undefined {
  return user.value?.currentEstate;
}

export function shouldInjectEstate(): boolean {
  return !!user.value?.currentEstate && !!user.value?.isViewingEstateDetails;
}

export function isGenericEstate(): boolean {
  return user.value?.currentEstate?.jurisdiction?.isGeneric ?? false;
}

export function isClearVault(): boolean {
  return user.value?.currentEstate?.type === EstateType.CLEAR_VAULT.key;
}

export function isClearEstate(): boolean {
  return user.value?.currentEstate?.type === EstateType.CLEAR_ESTATE.key;
}

export function isClearWill(): boolean {
  return user.value?.currentEstate?.type === EstateType.CLEAR_WILL.key;
}

export function getEchoInstance(): Echo | undefined {
  return echo.value;
}

export function getPermission(estate: Estate): AuthUserPermission {
  return user.value?.getPermission(estate) ?? new AuthUserPermission();
}
